import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter)
import accountList from './views/account/list.vue'; //用户列表
import authority from './views/account/authority.vue'; //权限管理
import home from './views/home/index.vue';
import orderList from './views/order/list.vue'; //订单列表
import reportList from './views/report/list.vue'; //报备列表
import addReport from './views/report/addReport.vue'; //添加报备
import siteList from './views/plan/siteList.vue'; //站点列表
import addSite from './views/plan/addSite.vue'; //添加站点
import myOffer from './views/order/my-offer.vue' //我的报价
import periphery from './views/plan/periphery.vue' //周边列表
import reserve from './views/report/reserve.vue' //我的预留
import examine from './views/examine/index.vue'
import message from './views/message/index.vue'
import downloadOrder from './views/order/downloadOrder.vue'
import sys_approve from './views/system/approve.vue'
import sys_setMeal_index from './views/system/setMeal/index.vue'
import sys_setMeal from './views/system/setMeal/setMeal.vue'
import myPoints from './views/plan/myPoints.vue'
import sys_banner from './views/system/setBanner/index.vue'
import sys_article from './views/system/setArticle/index.vue'
import sys_setBanner from './views/system/setBanner/banner.vue'
import sys_setArticle from './views/system/setArticle/article.vue'
const routes = [{
		path: '/',
		name: 'home',
		component: home
	},
	{
		path: '/accountList',
		name: 'accountList',
		component: accountList
	},
	{
		path: '/authority',
		name: 'authority',
		component: authority
	},
	{
		path: '/orderList',
		name: 'orderList',
		component: orderList
	},
	{
		path: '/reportList',
		name: 'reportList',
		component: reportList
	},
	{
		path: '/addReport',
		name: 'addReport',
		component: addReport
	},
	{
		path: '/siteList',
		name: 'siteList',
		component: siteList
	},
	{
		path: '/addSite',
		name: 'addSite',
		component: addSite
	},
	{
		path: '/myOffer',
		name: 'myOffer',
		component: myOffer
	},
	{
		path: '/periphery',
		name: 'periphery',
		component: periphery
	},
	{
		path: '/reserve',
		name: 'reserve',
		component: reserve
	},
	{
		path: '/examine',
		name: 'examine',
		component: examine
	},
	{
		path: '/message',
		name: 'message',
		component: message
	},
	{
		path: '/downloadOrder',
		name: 'downloadOrder',
		component: downloadOrder
	},
	{
		path: '/sys_approve',
		name: 'sys_approve',
		component: sys_approve
	},
	{
		path: '/sys_setMeal',
		name: 'sys_setMeal',
		component: sys_setMeal
	},
	{
		path: '/sys_setMeal_index',
		name: 'sys_setMeal_index',
		component: sys_setMeal_index
	},
	{
		path: '/myPoints',
		name: 'myPoints',
		component: myPoints
	},
	{
		path: '/sys_banner',
		name: 'sys_banner',
		component: sys_banner
	},
	{
		path: '/sys_article',
		name: 'sys_article',
		component: sys_article
	},
	{
		path: '/sys_setBanner',
		name: 'sys_setBanner',
		component: sys_setBanner
	},
	{
		path: '/sys_setArticle',
		name: 'sys_setArticle',
		component: sys_setArticle
	},
	// {
	//     path:'/page1',
	//     component:page1,
	//     children: [
	//         {
	//             path: "phone",
	//             component: phone
	//         },
	//         {
	//             path: "computer",
	//             component: computer
	//         },
	//     ]
	// },
	// {path:"/page2",component:page2},
	// // {path:'',redirect:"page1"}
	// {path:"",component:page1},
	// {path:"/user/:name",component:user}

]

const router = new VueRouter({
	mode: 'history',
	routes
});
router.beforeEach((to, from, next) => {
	//站点列表中编辑时，去其他页面将conditionObj缓存删除
	if(from.name == 'addSite'){
		let history = localStorage.getItem('conditionObj')
		if(history && to.name != 'siteList'){
			localStorage.removeItem('conditionObj')
		}
	}
	let isLogin = localStorage.getItem('isLogin')
	let token = localStorage.getItem('token')
	
	if (!isLogin) {
		location.href = '/login'
	} else {
		// 登录状态
		if (to.matched.length == 0) { //如果未匹配到路由，跳转到错误页面
			location.href = '/error'
		}else{
			next()
		}
	}
});
export default router
